import type { VoidFunctionComponent } from 'react';

import { FormLabelVariant, LabeledSelect } from '../../generic';
import { useReportFormatSelector } from '../hooks/useFormatSelector';
import type { AnyReportFormatOption } from '../types';

/**
 * Dropdown which allows the user to select the format of the report.
 */
export const FormatSelector: VoidFunctionComponent = () => {
  const { options, value, setFormat } = useReportFormatSelector();
  return (
    <div>
      <LabeledSelect<AnyReportFormatOption>
        id="report-format"
        label="Format"
        variant={FormLabelVariant.Filter}
        value={value}
        options={options}
        onChange={setFormat}
      />
    </div>
  );
};
